<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">非配额订单</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        disabled
        label-width="100px"
        :model="conditions"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="订单编号">
              <el-input
                v-model="conditions.OBJECT_ID"
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="订单类型">
              <el-select
                v-model="conditions.PROCESS_TYPE"
                placeholder=""
              >
                <el-option
                  v-for="item in selectDataOptions['A0043']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.CUST_NAME"
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="CUSTOMER" label="客户编号">
              <el-input v-model="conditions.CUSTOMER" />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="conditions.CUSTOMER_TYPE" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input :value="conditions.ZCUSTOM_NAME" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.ZZFLD000028"
                type="textarea"
                rows="4"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.ZZFLD00002D_DSCR"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.POSTING_DATE"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                v-model="conditions.STATUS"
                placeholder=""
              >
                <el-option
                  v-for="item in selectDataOptions['A0041']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="ZZFLD000001">
              <el-input v-model="conditions.ZZFLD000001_TEXT" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input
                v-model="conditions.ZZFLD00003E"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input
                v-model="conditions.ZZFLD000002_TEXT"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input
                v-model="conditions.ZZFLD000003_TEXT"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                v-model="conditions.ZZFLD000004_DSCR"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="运达方" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="收货方">
              <el-input v-model="conditions.ZZFLD00008T_DSCR" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人">
              <el-input v-model="conditions.ZZFLD00002L" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人电话">
              <el-input v-model="conditions.ZZFLD00002M" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="地址">
              <el-input v-model="conditions.ZZFLD00002N" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售订单行项目" :custome-config="() => vxeShowCustom('orderDetail')">
        <vxe-grid
          ref="orderDetail"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.orderDetailcolumns"
          :data="gridOptions.orderData"
        >
          <template v-for="item in gridOptions.orderDetailcolumns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-select
                v-if="gridOptions.columnsFieldTypes[item.field] == 'select'"
                v-model="row[item.field]"
                placeholder=""
                disabled
                size="mini"
              >
                <el-option
                  v-for="item2 in selectDataOptions['A0037']"
                  :key="item2.value"
                  :label="item2.name"
                  :value="item2.value"
                />
              </el-select>
              <el-checkbox
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'checkbox'"
                v-model="row[item.field]"
                disabled
              >是</el-checkbox>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.fileDetailColumns"
          :data="gridOptions.fileData"
        >
          <template #FILENAME="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable3')">
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>

      <TableCommon title="关联单据" :custome-config="() => vxeShowCustom('gridOptionsLinkBill')">
        <vxe-grid
          ref="gridOptionsLinkBill"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsLinkBill.columns"
          :data="gridOptionsLinkBill.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { sapDownloadFile } from '@/utils/frontExport'
import { getOrderDetail } from '@/api/sap/order-sap'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

export default {
  data() {
    return {
      conditions: {
        OBJECT_ID: '', // 订单编号
        PROCESS_TYPE: 'ZS02', // 订单类型
        CUSTOMER: '', // 客户编码
        CUST_NAME: '', // 客户名称
        CUSTOMER_TYPE: '', // 客户类型
        ZZFLD00000: '', // 审核意见
        ZZFLD000028: '', // 备注
        ZZFLD00002D: '', // 创建人编号
        ZZFLD00002D_DSCR: '', // 创建人描述
        POSTING_DATE: '', // 创建时间
        ZCUSTOM_NAME: '',
        STATUS: 'E0001', // 状态
        ZZFLD000001: '', // 营销单元
        ZZFLD000001Name: '',
        ZZFLD00003E: '', // 基地
        ZZFLD00003EName: '',
        ZZFLD000002: '', // 省区
        ZZFLD000003: '', // 城市
        ZZFLD000004: '', // 业务员
        ZZFLD000004_DSCR: '', // 业务员描述
        ZZFLD00002J: '', // 客户性质
        ZZFLD00002K: '', // 发货类型
        ZZFLD00002L: '', // 收货联系人
        ZZFLD00002M: '', // 收货联系电话
        ZZFLD00008T: '', // 收货方
        ZZFLD00008T_DSCR: '', // 收货方
        ZHKYE: '', // 货款余额
        slbzj: '',
        gdbzj: '',
        kpyq: ''
      },
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        orderDetailcolumns: [
          { field: 'checkbox', type: 'checkbox', title: '', width: 60 },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 140,
            slots: { default: 'ORDERED_PROD' },
            editRender: {}
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 180,
            slots: { default: 'DESCRIPTION' }
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 100,
            slots: { default: 'ZZFLD00002S' }
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80,
            slots: { default: 'ZZFLD00002T' }
          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80,
            slots: { default: 'ZZFLD00002U' }
          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80,
            slots: { default: 'ZZFLD000009' },
            editRender: {}
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80,
            slots: { default: 'ZZFLD00002E' }
          },
          {
            field: 'ZZFLD00002X',
            title: '含税单价',
            width: 100,
            slots: { default: 'ZZFLD00002X' }
          },
          {
            field: 'ZZFLD00002Z',
            title: '价税合计',
            width: 100,
            slots: { default: 'ZZFLD00002Z' }
          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100,
            slots: { default: 'ZZFLD00002F' }
          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180,
            slots: { default: 'ZZFLD00002G' }
          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180,
            slots: { default: 'ZZFLD00002O' }
          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180,
            slots: { default: 'ZZFLD000035' }
          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180,
            slots: { default: 'ZZFLD000007' }
          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180,
            slots: { default: 'ZZFLD000032' }
          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: { default: 'ZZFLD00002B' }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' }
          }
        ],
        orderData: [],
        fileDetailColumns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 80 },
          { type: 'seq', field: 'seq', title: '序号' },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'FILENAME' }},
          { field: 'MIMETYPE', title: '附件类型' },
          { field: 'FILELENGTH', title: '大小' },
          { field: 'CREATED_TIME', title: '上传时间' }
        ],
        fileData: [],
        columnsFieldTypes: {
          default: '',
          ORDERED_PROD: 'selectProduct',
          ZZFLD000009: 'input',
          ZZFLD00002A: 'select',
          ZZFLD00002I: 'input',
          ZZFLD00002B: 'checkbox',
          ZZFLD000008: 'input'
        }
      },
      gridOptionsLinkBill: {
        buttons: [],
        columns: [
          {
            field: 'ZZFLD000011',
            title: '单据编号'
          },
          {
            field: 'ZZFLD000012_TEXT',
            title: '单据类型'
          },
          {
            field: 'ZZFLD000013',
            title: '创建日期'
          }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ZZFLD00000U', title: '操作人' },
          { field: 'ZZFLD00000V_TEXT', title: '状态' },
          { field: 'ZZFLD00000W', title: '变更日期' }
        ],
        data: []
      }
    }
  },
  created() {
    const pageQuery = this.$route.query
    this.initOrderInfoById(pageQuery.object_id)
    // 折扣类型
    this.getSelectDictDataOrigin('A0037')
    // 非配额酒销售订单状态
    this.getSelectDictDataOrigin('A0041')
    // 销售订单类型
    this.getSelectDictDataOrigin('A0043')
    // 客户类型
    this.getSelectDictDataOrigin('A0009')
  },
  methods: {
    // 根据id查询订单信息
    async initOrderInfoById(OBJECT_ID) {
      const res = await getOrderDetail({ OBJECT_ID })
      if (res?.MSGTYPE === 'S') {
        const { DATA } = res
        Object.assign(this.conditions, DATA.INFO)
        this.gridOptions.orderData = DATA.ITEM
        this.gridOptions.fileData = DATA.ATTACHMENT
        this.gridOptionsHistory.data = DATA.HISTORY || []
        this.gridOptionsLinkBill.data = DATA.CONNECT || []
      }
    },
    // 初始化数据字典
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT, row.FILENAME)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-form {
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-manage/components/noQuotaOrderCheck.vue